export const CONTENT_METRIC_INPUT_SCREENSHOT = 'screenshot';
export const CONTENT_METRIC_INPUT_MANUAL = 'manual';
export const CONTENT_METRIC_MANUAL_DISPLAY_TEXT = 'Available content metrics were auto-synced from your post. Please input any missing metrics in the blank fields below.';
export const CONTENT_METRIC_SCREENSHOT_INFO_HEADER_TEXT = 'What screenshots should I upload?';
export const CONTENT_METRIC_SCREENSHOT_ACCEPTED_FILE_TYPES_TEXT = 'Files accepted: jpg, jpeg, png, bmp. Up to 500mb per file.';
export const CONTENT_TYPE_STORY = 'story';
export const CONTENT_TYPE_POST = 'post';
export const CONTENT_TYPE_REEL = 'reel';
export const MANUAL_STAT_FIELD_LABEL_MAP = {
    impressions: 'Impressions',
    comments: 'Comments',
    likes: 'Likes',
    saves: 'Saves',
    shares: 'Shares',
    reach: 'Reach',
    views: 'Views',
    replies: 'Story Replies'
};
export const MANUAL_STAT_POST_TYPE_FIELD_MAP = [
    {
        type: CONTENT_TYPE_POST,
        fields: ['impressions', 'comments', 'likes', 'saves', 'shares', 'reach']
    },
    {
        type: CONTENT_TYPE_REEL,
        fields: ['comments', 'likes', 'saves', 'shares', 'reach', 'views']
    },
    {
        type: CONTENT_TYPE_STORY,
        fields: ['impressions', 'likes', 'saves', 'shares', 'reach', 'replies']
    }
];
